/**
 * @generated SignedSource<<e0fd1eefe43e18914b5346db36762ffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent$data = {
  readonly isHoveredOrFocused: boolean | null | undefined;
  readonly " $fragmentType": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent";
};
export type popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent$key = {
  readonly " $data"?: popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent$data;
  readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHoveredOrFocused"
        }
      ]
    }
  ],
  "type": "JiraFieldHoverOrFocusState"
};

(node as any).hash = "adedc2066b3d1f1bf4ceaa4892e0e21a";

export default node;
